export default function Field({ label, hint, value, onChange, placeholder, testId, rows = 5 }) {
  return (
    <div>
      <label className="block ks-kicker mb-2" htmlFor={testId}>{label}</label>
      {hint && <p className="text-[15px] text-[color:var(--ks-ink-soft)] mb-3 leading-[1.5]">{hint}</p>}
      <textarea
        id={testId}
        className="ks-field"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        data-testid={testId}
      />
    </div>
  );
}
